import { IGetters } from './getters.types'
import { IGrantAmendmentData } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants';
import {Utilities as _utils} from '@/shared/utilities';

export const getters: IGetters = {
    /** get the list of indicators */
    indicators(state: IGrantAmendmentData): any {
        return state.indicators;
    },
    applicationId(state: IGrantAmendmentData): any {
        return state.grantAmendmentDetail.ApplicationId;
    },
    /** get the root template based on the language selected */
    rootTemplate (state: IGrantAmendmentData): any {
        return state.schema;
    },

}